module.exports = __webpack_public_path__ + "static/media/ellipsis-v-alt.7a58a88e.svg";